import { action } from "typesafe-actions";
import ActionTypes from "../../constants";

export const onePagePrequoteLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_prequote_vms_success",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onePagePrequoteScreeenLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_prequote_screen",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const mmvCardEdit = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_mmv_card_edit",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const viewPageMMVEdit = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_select_mmv_registration_year",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const makeModelClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_car_make_model",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const makeModelListLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "car_make_model_list_loaded",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const popularMakeModelSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "popular_car_make_model_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnFuelType = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_fuel_type",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const fuelTypeListLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "fuel_type_list_loaded",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const fuelTypeListSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "fuel_type_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnVariant = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_car_variant",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });
export const carVariantSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "car_variant_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const carVariantListLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "car_variant_list_loaded",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnRegYear = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_reg_year",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const regYearMonthLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "registration_year_month_list_loaded",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const regYearMonthSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "registration_year_month_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const selectMMVRegYearConitnue = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_select_mmv_registration_year_continue",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ppedEditClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_pped_edit",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tpPpedEditClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_tp_pped_edit",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const odPpedEditClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_od_pped_edit",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const typedMakeModelSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "typed_car_make_model_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

// PREQUOTE PPED START
export const ppedCalendarLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "select_pped_calendar_loaded",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ppedForgotSeg = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_pped_forgot",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ppedRangeOptionsLoadedSeg = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "select_pped_expirystatus_loaded",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ppedExpiredNotExpiredSelectedSeg = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "expirystatus_bottomsheet_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ppedNotExpiredOptionSelectedSeg = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "notexpired_options_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ppedExpiredOptionSelectedSeg = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "expired_options_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const rememberPPEDSelectedSeg = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_pped_known",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

// PREQUOTE PPED END

export const ppedSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "pped_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ncbClaimSkipped = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "ncb_last_claim_question_skipped",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const lastClaimYearSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_last_year_claim",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const selectNCBClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_ncb_select",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ncbHelperClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_how_to_select",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const ncbSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "ncb_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const isCommercialAnswered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_is_commercial",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const externalCngAnswered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_external_cng_kit",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const pincodeAutofilled = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "pincode_autofill",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const phoneAutofilled = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "phone_number_autofill",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const phoneEntered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "phone_number_entered",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tncClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_prequote_tnc",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const viewPlansClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_view_plans",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const autofillNCBUpdated = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "autofill_ncb_updated",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const viewPageEnterNewCarDetails = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_enter_new_car_details",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnEnterNewCarDetailsCta = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_enter_new_car_details_cta",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const viewPageNewCarFewMoreDetails = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_new_car_few_more_details",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnNewCarFewMoreDetailsCta = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_new_car_few_more_details_cta",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });
export const viewPPEDScreen = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_pped_screen",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });
export const tapCTAPPEDScreen = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_pped_screen_cta",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });
export const viewNCBScreen = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_ncb_screen",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });
export const tapCTANCBScreen = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_ncb_screen_cta",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

// __________________________________________
// # Vehicle details
// view_page_enter_new_car_details
// tap_btn_enter_new_car_details_cta
// tap_btn_is_commercial --
// new_car_delivery_date_entered

// viewPageEnterNewCarDetails
// tapBtnEnterNewCarDetailsCta
// tapBtnIsCommercial
// newCarDeliveryDateEntered
// __________________________________________

// __________________________________________
//  # User details
// view_page_new_car_few_more_details
// tap_btn_new_car_few_more_details_cta
// tap_btn_vehicle_summary_edit --
// mobile_number_entered --
// pincode_entered --

// viewPageNewCarFewMoreDetails
// tapBtnNewCarFewMoreDetailsCta
// tapBtnVehicleSummaryEdit
// mobileNumberEntered
// pincodeEntered
// __________________________________________

// __________________________________________
/* # Plans screen
plan_not_serviceable
view_page_plan_screen --
tap_btn_plan_screen_cta --
tap_btn_vehicle_summary_edit --
tap_btn_3tp_1od_learn_more
tap_btn_plan_see_details --
tap_btn_idv_edit --
tap_btn_idv_updated -- */

// planNotServiceable
// viewPagePlanScreen
// tapBtnPlanScreenCta
// tapBtnVehicleSummaryEdit
// tapBtn3Tp1OdLearnMore
// tapBtnPlanSeeDetails
// tapBtnIdvEdit
// tapBtnIdvUpdated
// __________________________________________

// __________________________________________
/* # Addons screen
view_page_family_addon --
tap_btn_family_addon_cta --
view_page_car_addon --
tap_btn_car_addon_cta --
tap_btn_addon_card_read_more --
tap_btn_addon_see_how_it_works --
addon_info_nudge_modal_loaded --
tap_btn_info_nudge_modal_add_addon --
tap_btn_info_nudge_modal_continue_without_addon -- */

// viewPageFamilyAddon
// tapBtnFamilyAddonCta
// viewPageCarAddon
// tapBtnCarAddonCta
// tapBtnAddonCardReadMore
// tapBtnAddonSeeHowItWorks
// addonInfoNudgeModalLoaded
// tapBtnInfoNudgeModalAddAddon
// tapBtnInfoNudgeModalContinueWithoutAddon
// __________________________________________

// __________________________________________
/* # IDV screen
view_page_customize_idv_screen
tap_btn_idv_updated --
tap_btn_customize_idv_screen_cta */

// viewPageCustomizeIdvScreen
// tapBtnIdvUpdated
// tapBtnCustomizeIdvScreenCta
// __________________________________________

/* # Checkout screen
view_page_checkout --
tap_btn_checkout_cta  --
user_name_entered --
email_id_entered --
mobile_number_entered --
rto_zone_entered 
gstin_no_entered -- 
engine_number_entered
chassis_number_entered
tap_btn_engine_chassis_learn_more
tap_btn_car_loan_learn_more

*/

// viewPageCheckout
// tapBtnCheckoutCta
// userNameEntered
// emailIdEntered
// mobileNumberEntered
// rtoZoneEntered
// gstinNoEntered
// engineNumberEntered
// chassisNumberEntered
// tapBtnEngineChassisLearnMore
// tapBtnCarLoanLearnMore

/*  OTP SCREEN
enter_otp_modal_loaded --
tap_btn_verify_otp --
error_invalid_otp --
tap_btn_resend_otp --
otp_autofilled --
*/
// enterOtpModalLoaded
// tapBtnVerifyOtp
// errorInvalidOtp
// tapBtnResendOtp
// otpAutofilled

/* Review Screen 
view_page_review --
tap_btn_review_cta --
tap_btn_car_details_edit
tap_btn_car_owner_details_edit
recommended_coupon_loaded --
tap_btn_coupon_applied --
*/

// viewPageReview
// tapBtnReviewCta
// tapBtnCarDetailsEdit
// tapBtnCarOwnerDetailsEdit
// recommendedCouponLoaded
// tapBtnCouponApplied

//
